export const NAVIGATE_AUTH = {
    AUTH: "/auth",
    LOGIN: "/login",
    LOGOUT: "/logout",
    REGISTER: "/register",
    get LOGIN_PAGE() { return `${this.AUTH}${this.LOGIN}`; },
    get LOGOUT_PAGE() { return `${this.AUTH}${this.LOGOUT}`; },
}

export const NAVIGATE_MODULE = {
    HOME: "/",
    USER: '/user',
    get HOME_PAGE() { return `${this.HOME}`; },
}

export const ERROR = {
    ERROR_403: "/403",
    get ERROR_403_PAGE() { return `${this.ERROR_403}`; },
}

export const NAVIGATE_ADMIN = {
    ADMIN: "/admin",
    USER_PROFILE: "/user-profile",
    UserList: "/user-list",
    DONOR_LIST: "/user/donor",
    VOLUNTEER_LIST: "/user/volunteers",
    VOLUNTEER_DETAILS: "/user/volunteers/details",
    CSRCELL_LIST: "/user/csr-cell",
    IMPL_AGENCY_LIST: "/user/implementing-agency",
    GOV_LIST: "/user/government",
    DASHBOARD: "/dashboard",
    REG_USER_DETAILS: "/registered-user-details",
    IMPLEMNETING_LIST: "/registered-agencies",
    WORKFLOW_LIST: "/workflow-list",
    FINANCIAL_MANAGEMENT: "/financial-management/fund-disbursement-utilization",
    FINANCIAL_MANAGEMENT_OVERVIEW: "/financial-management/financial-management-overview",
    IA_AGENCY: "/implementing_agency",
    IA_AGENCY_LIST: "/implementing-agencies",
    IA_AGENCY_MAPPED_LIST: "/implementing-agency/mapped-projects",
    RESET_PASSWORD: "/reset-password",
    HELP_SUPPORTS: "/help-support",

    ROLES_MASTER: "/master/roles",
    MENU_MASTER: "/master/menu",
    THEMES_MASTER: "/master/themes",
    PERMISSION_MASTER: "/master/permission",
    WORKFLOW_MASTER: "/master/workflow",

    SEWA_MASTER: "/master/sewa",
    SEWA_DAL_MASTER: "/master/sewa-dal",
    SEWA_CATEGORY_MASTER: "/master/sewa-category",

    get USERLIST() { return `${this.ADMIN}${this.UserList}`; },
    get USER_LIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.UserList}` },
    get IA_AGENCY_MAPPED_LIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.IA_AGENCY_MAPPED_LIST}` },
    get IMPL_AGENCY_LIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.IMPL_AGENCY_LIST}` },
    get FINANCIAL_MANAGEMENT_OVERVIEW_LIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.FINANCIAL_MANAGEMENT_OVERVIEW}` },
}

export const NAVIGATE_MASTERS = { MASTERS: "/masters", }

export const WORKFLOW_MASTERS = { WORKFLOW_LIST: "/workflow-list" }

export const NAVIGATE_UTILITY = {
    UTILITY: "/utility",
    get UTILITY_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.UTILITY}`; },
}

export const NAVIGATE_PROFORMA_INVOICE = {
    PROFORMA_INVOICE: "/proforma-invoice",
    get PROFORMA_INVOICE_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.PROFORMA_INVOICE}`; },
}

export const NAVIGATE_SETUP_SECTIONS = {
    SETUP_SECTIONS: "/setup",
    get SETUP_SECTIONS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.SETUP_SECTIONS}`; },
}

export const NAVIGATE_REPORTS = {
    REPORTS: "/reports",
    ALL_REPORTS: "/all",
    get REPORTS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.REPORTS}`; },
}



export const NAVIGATE_PROJECT = {
    PROJECTS: "/project",
    PROJECTS_LIST: "/project-listing",
    AGENCY_PROJECTS_LIST: "/agency-projects",
    DONOR_PROJECTS_LIST: "/donor-projects",
    My_PROJECTS: "/my-projects",
    COMPLETED_PROJECTS: "/projects/completed-projects",
    My_INTERESTED_PROJECTS: "/projects/my-interested",
    My_COMMITED_PROJECTS: "/projects/my-committed",
    My_ONGOING_PROJECTS: "/projects/ongoing",
    All_COMMITTED_PROJECTS: "/projects/all-commitements",
    PROJECTS_CREATE_FORM: "/project-creation",
    PROJECTS_APPROVAL: "/approval-pending",
    PROJECTS_DETAILS: "/project-details",

    get PROJECTS_LIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.PROJECTS_LIST}` },
    get My_INTERESTED_PROJECTS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.My_INTERESTED_PROJECTS}` },
    get My_COMMITED_PROJECTS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.My_COMMITED_PROJECTS}` },
    get ALL_COMMITED_PROJECTS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.All_COMMITTED_PROJECTS}` },
    get ALL_DONOR_PROJECTS_LIST() { return `${NAVIGATE_ADMIN.ADMIN}${this.DONOR_PROJECTS_LIST}` },
    get ALL_AGENCY_PROJECTS_LIST() { return `${NAVIGATE_ADMIN.ADMIN}${this.AGENCY_PROJECTS_LIST}` },
}

export const NAVIGATE_ALL_MASTER = { MASTER: "masters", }

export const NAVIGATE_KNOWLEDGE_BASE = {
    KNOWLEDGE: "/knowledge",
    KNOWLEDGE_LIST: "/knowledge-base",
    KNOWLEDGE_CREATE_FORM: "/knowledge-base/details",

}

export const NAVIGATE_EVENT_AND_MEDIA = {
    EVENTANDMEDIA: "/event-and-media",
    MEDIA: "/event-and-media/media-gallery",
    PAST_EVENTS: "/event-and-media/past-events",
    UPCOMING_EVENTS: "/event-and-media/upcoming-events",
    UPCOMING_EVENTS_DETAILS: "/event-and-media/upcoming-events-details",
    ADD_EVENT: "/event-and-media/add-upcomming-event"
}

export const NAVIGATE_CSR_COMMITEE_LIST = { CSRLIST: "/csr-commitee", }

export const NAVIGATE_NOTIFICATION = { NOTIFICATION_DETAILS: "/notification-details", }

export const NAVIGATE_TENDER = { TENDER_LIST: "/tender-list", }

export const NAVIGATE_USERS = {
    USERS: "/users",
    ALL_USERS: "/company-users",
    get USERS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.USERS}`; },
}

export const NAVIGATE_DONOR_DASHBOARD = { DONOR: "/donor-dashboard", }

export const NAVIGATE_GOV_DASHBOARD = { GOV_DASHBOARD: "/gov-agency-dashboard", }